import { inject } from '@angular/core';
import { ModalService } from '../../shared/services/modal/modal.service';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { QueryParams } from '../../shared/models/query/queryParams.model';
import { HistoriqueBilat } from '../models/historique-bilat/historique-bilat.models';
import { QueryService } from '../service/historique-bilat.service';

type HistoriqueBilatStore = {
  listBilat: HistoriqueBilat.Get[];
  detailBilat: HistoriqueBilat.GetDetailBilat;
  customerBilat: HistoriqueBilat.CustomerBilat[];
  total: number;
  loading: boolean;
};

export const initialHistoriqueBilatStore: HistoriqueBilatStore = {
  listBilat: [],
  detailBilat: {
    bilat_creation_date: '',
    bilat_end_date: '',
    bilat_id: 0,
    bilat_comment: '',
    customer_count: 0,
    fullname_manager: '',
    fullname_seller: '',
    time_passed_in_bilat: 0,
  },
  customerBilat: [],
  total: 0,
  loading: false,
};

export const historiqueBilatStore = signalStore(
  { providedIn: 'root' },
  withState(initialHistoriqueBilatStore),
  withMethods((store, queryService = inject(QueryService), modalService = inject(ModalService)) => ({
    getHistoriqueBilat: (id_seller: number, type: string, queryParams: QueryParams.QueryParamsPagination) => {
      patchState(store, { loading: true });
      queryService.getHistoriqueBilat(id_seller, type, queryParams).subscribe({
        next: (response) => {
          if (response.body != null) {
            patchState(store, { listBilat: response.body[0], total: response.body[1] });
          } else {
            throw new Error('Error while fetching historique bilat');
          }
        },
        error: (error) => {
          console.error(error);
          modalService.openAlert('error', 'Erreur', "Impossible de récuperer l'historique des bilat", () => {
            modalService.closeAlert();
          });
        },
        complete: () => {
          patchState(store, { loading: false });
        },
      });
    },
    getDetailBilat: (id_bilat: number) => {
      patchState(store, { loading: true });
      queryService.getDetailBilat(id_bilat).subscribe({
        next: (response) => {
          if (response.body != null) {
            patchState(store, {
              detailBilat: {
                bilat_creation_date: response.body.bilat_creation_date,
                bilat_end_date: response.body.bilat_end_date,
                bilat_id: response.body.bilat_id,
                bilat_comment: response.body.bilat_comment,
                customer_count: response.body.customer_count,
                fullname_manager: response.body.fullname_manager,
                fullname_seller: response.body.fullname_seller,
                time_passed_in_bilat: response.body.time_passed_in_bilat,
              },
            });
          } else {
            throw new Error('Error while fetching detail bilat');
          }
        },
        error: (error) => {
          console.error(error);
          modalService.openAlert('error', 'Erreur', 'Impossible de récuperer les détails du rapport bilat', () => {
            modalService.closeAlert();
          });
        },
        complete: () => {
          patchState(store, { loading: false });
        },
      });
    },
    getCustomerBilat: (id_bilat: number) => {
      patchState(store, { loading: true });
      queryService.getCustomerBilat(id_bilat).subscribe({
        next: (response) => {
          if (response.body != null) {
            patchState(store, { customerBilat: response.body[0] });
          } else {
            throw new Error('Error while fetching historique bilat');
          }
        },
        error: (error) => {
          console.error(error);
          modalService.openAlert('error', 'Erreur', 'Impossible de récuperer les clients de la bilat', () => {
            modalService.closeAlert();
          });
        },
        complete: () => {
          patchState(store, { loading: false });
        },
      });
    },
    setComment: (idBilat: number, comment: string, fromModal: boolean) => {
      patchState(store, { loading: true });
      queryService.setComment(idBilat, comment).subscribe({
        next: (response) => {
          if (response.body) {
            if (fromModal) {
              patchState(store, { detailBilat: { ...store.detailBilat(), bilat_comment: comment } });
            } else {
              window.location.reload();
            }
          } else {
            throw new Error('Error while assigning comment to bilat');
          }
        },
        error: (error) => {
          console.error(error);
          modalService.openAlert('error', 'Erreur', "Erreur lors de l'ajout du commentaire", () => {
            modalService.closeAlert();
          });
        },
        complete: () => {
          patchState(store, { loading: false });
        },
      });
    },
  })),
);
